import { PropsWithChildren, useState } from 'react';
import { Button } from 'reactstrap';
import ModalClient from 'components/modal/ModalClient';
import { Briefcase } from 'react-feather';
import { useTranslation } from 'react-i18next';

export const ButtonClientPicker: React.FC<PropsWithChildren> = ({
  children,
}: PropsWithChildren) => {
  const [modal, setModal] = useState(false);
  const toggleModalClient = () => setModal((prev) => !prev);

  return (
    <>
      <ModalClient show={modal} toggleFunc={toggleModalClient} />
      <Button onClick={toggleModalClient} className="bg-transparent border-0 p-0">
        {children}
      </Button>
    </>
  );
};

export const IconButtonClientPicker: React.FC = () => {
  const { t } = useTranslation();
  return (
    <ButtonClientPicker>
      <span
        className="p-2 rounded-circle bg-light nav-link"
        role="button"
        title={`${t('customer.select')}`}
      >
        <Briefcase />
      </span>
    </ButtonClientPicker>
  );
};
